import { render, staticRenderFns } from "./AppThemeToggle.vue?vue&type=template&id=51f23ff8&scoped=true&"
import script from "./AppThemeToggle.vue?vue&type=script&lang=js&"
export * from "./AppThemeToggle.vue?vue&type=script&lang=js&"
import style0 from "./AppThemeToggle.vue?vue&type=style&index=0&id=51f23ff8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f23ff8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
